import axios from "api/axios"
import { APIResponse, ConfigWithURLParams } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { Product, ProductAfterTax } from "./types"
import { urls } from "./urls"

export default {
  getProduct: async ({
    params,
    urlParams,
  }: ConfigWithURLParams<"productSlug">): Promise<APIResponse<Product>> => {
    try {
      const res = await axios.get(urls.getProduct(urlParams.productSlug), {
        params,
        headers: {
          Authorization: null,
        },
      })
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },

  getProductTax: async ({ data }): Promise<APIResponse<ProductAfterTax>> => {
    try {
      const res = await axios.post(urls.getProductTax(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
